export default "__VITE_ASSET__kmkX4FsW__"